export default [
    {
        NAME: 'Greg Holley',
        EMAIL: 'gholley@highstcapital.com',
        INITIALS: 'GH',
        TITLE: 'Managing Partner',
        PHONE_NUMBER: '(469) 998-7200'
    },
    /* {
        NAME: 'Jimmy Arnold',
        EMAIL: 'jarnold@highstcapital.com',
        INITIALS: 'JA',
        TITLE: 'Associate',
        PHONE_NUMBER:'(469) 998-7201'
    } */
];